var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lm-loading",class:{ 'absolute': _vm.absolute }},[_c('a-icon',{style:({ 'font-size': '4rem', 'color': _vm.color }),attrs:{"type":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }